import { render, staticRenderFns } from "./new-year-gift.vue?vue&type=template&id=515ea1be&scoped=true&"
import script from "./new-year-gift.vue?vue&type=script&lang=js&"
export * from "./new-year-gift.vue?vue&type=script&lang=js&"
import style0 from "./new-year-gift.vue?vue&type=style&index=0&id=515ea1be&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515ea1be",
  null
  
)

export default component.exports